import React from "react";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import { ActionButton } from "@fluentui/react/lib/Button";
import { ContextualMenu } from "@fluentui/react";
import { fetchChildrenDimension, mapDimensionToDimensionItem } from "../../../api/object/Dimensions";
import { TreeDropDownInput } from "../../coobjects/tree-pills-input/TreeInput";
import { CollapsableCard } from "../../layout/CollapsableCard";
import useDocumentParametersCard, { DocumentParametersCardProps } from "./DocumentParametersCardHook";

export const DocumentParametersCard: React.FunctionComponent<DocumentParametersCardProps> = (props) => {
  const {
    state,
    setState,
    dimensions,
    onChangeToggle,
    selectedDbApplication,
    canInherit,
    inheritableDbParameters,
    updateDimensionFromTree,
    removeDimension,
    filteredDimensions,
    addDimensionLinkRef,
    getHeaderComponent,
    readonly,
  } = useDocumentParametersCard(props);

  return (
    <CollapsableCard
      externalState={{
        isExpanded: state.expandCard,
        setExpanded: (expanded) => setState((s) => ({ ...s, expandCard: expanded })),
      }}
      headerComponent={({ isExpanded, setExpanded }) =>
        getHeaderComponent({
          setExpanded,
          isExpanded,
          dimensions,
          onChangeToggle,
          selectedDbApplication,
          readonly,
        })
      }
    >
      {state.selectedDimensionsItems.map((dimensionItem, index, arr) => {
        const thisDimensionsDetails = dimensions?.filter((d) => d.dimensionOid === dimensionItem.oid);
        return (
          <TreeDropDownInput
            key={dimensionItem.oid + "DropDown"}
            fetchRoot={async (oid) => {
              const items = await fetchChildrenDimension(selectedDbApplication.id, oid);
              return items.map((i) => mapDimensionToDimensionItem(i));
            }}
            fetchChildren={async (item) => {
              const items = await fetchChildrenDimension(selectedDbApplication.id, item.data.oid);
              return items.map((i) => mapDimensionToDimensionItem(i));
            }}
            dimensions={thisDimensionsDetails}
            canInherit={
              canInherit &&
              (inheritableDbParameters?.dimensions ?? []).filter((d) => d.dimensionOid === dimensionItem.oid)
            }
            inherited={thisDimensionsDetails?.[0]?.inherited}
            label={dimensionItem.desc}
            modalTitle={dimensionItem.desc}
            placeholder={formatMessage("cof.base.select")}
            rootOid={dimensionItem.oid}
            hierarchical={dimensionItem.hierarchical}
            multiSelectable={dimensionItem.multiSelectable}
            disabled={!!readonly}
            onChange={(newDimension) => {
              if (readonly) return;
              updateDimensionFromTree(dimensionItem, newDimension);
            }}
            onRemove={() => {
              if (readonly) return;
              removeDimension(dimensionItem);
              arr.splice(index, 1);
              setState((s) => ({
                ...s,
                userSelectedDimensionsItems: arr,
                isContextualMenuOpen: false,
                dimensions: dimensions.filter((d) => d.dimensionOid === dimensionItem.oid),
              }));
            }}
            dbId={selectedDbApplication?.id}
            isSearchAvailable={true}
          />
        );
      })}
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
          <ActionButton
            iconProps={{ iconName: "CircleAdditionSolid" }}
            disabled={!!readonly || !filteredDimensions?.length}
            onClick={() => {
              if (readonly) return;
              setState((s) => ({ ...s, isContextualMenuOpen: true }));
            }}
            style={{
              float: "left",
              marginBottom: "5px",
            }}
          >
            <b ref={addDimensionLinkRef} style={{ color: readonly ? "var(--color-grey)" : "var(--color-blue)" }}>
              {formatMessage("cof.base.adddimension")}
            </b>
          </ActionButton>
          {state.isContextualMenuOpen && (
            <ContextualMenu
              target={addDimensionLinkRef}
              items={filteredDimensions?.map((d) => ({
                key: d.oid,
                text: d.desc,
                onClick: () => {
                  setState((s) => ({
                    ...s,
                    isContextualMenuOpen: false,
                    selectedDimensionsItems: [...s.selectedDimensionsItems, d],
                  }));
                },
              }))}
              onDismiss={() => {
                setState((s) => ({
                  ...s,
                  isContextualMenuOpen: false,
                }));
              }}
            />
          )}
        </div>
      </div>
    </CollapsableCard>
  );
};
